export const galleryItems = [
  // תמונות בהירות - Light/Bright Images
  // תמונה #22 - Fashion photoshoot (bright outdoor/studio lighting)
  {
    id: "22",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/POP_UP_RISHPON_BY_EYAL_GAZIEL_012_jsptzg.jpg",
    url: "#",
    height: 300,
    eventName: "תמונה מאירוע צילומי אופנה",
    clientQuote: "הצוות הוסיף אלגנטיות ויוקרה לכל הסט"
  },
  // תמונה #17 - Bright business event
  {
    id: "17",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/DSC03508_imooxi.jpg",
    url: "#",
    height: 240,
    eventName: "תמונה מאירוע עסקי",
    clientQuote: "המקצועיות והחדשנות היו במיטב שראינו"
  },
  // תמונה #16 - Well-lit private event
  {
    id: "16",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/DSC03301_kvam86.jpg",
    url: "#",
    height: 320,
    eventName: "תמונה מאירוע פרטי",
    clientQuote: "כל קוקטייל היה הפתעה טעימה חדשה"
  },
  // תמונה #2 - Amazon event (corporate bright)
  {
    id: "2",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8019_fv21tc.jpg",
    url: "#",
    height: 240,
    eventName: "תמונה מאירוע של AMAZON",
    clientQuote: "האירוע היה מדהים והצוות מקצועי"
  },
  // תמונה #25 - Bright contemporary
  {
    id: "25",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561478/IMG_7840_gqfe33.jpg",
    url: "#",
    height: 320,
    eventName: "תמונה מאירוע חדש",
    clientQuote: "רגע מושלם שנתפס במצלמה"
  },

  // תמונות בינוניות-בהירות - Medium-Bright Images
  // תמונה #7 - Wedding event
  {
    id: "7",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/2_xxogqf.jpg",
    url: "#",
    height: 260,
    eventName: "תמונה מאירוע חתונה",
    clientQuote: "הבר הפך את החתונה שלנו לבלתי נשכחת"
  },
  // תמונה #6 - Google event
  {
    id: "6",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/1_uy4xdv.jpg",
    url: "#",
    height: 350,
    eventName: "תמונה מאירוע של Google",
    clientQuote: "השירות היה מעל ומעבר לכל דמיון"
  },
  // תמונה #8 - Birthday event
  {
    id: "8",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/3_eb2dfc.jpg",
    url: "#",
    height: 300,
    eventName: "תמונה מאירוע יום הולדת",
    clientQuote: "כל האורחים היו מרוצים מהקוקטיילים המיוחדים"
  },
  // תמונה #10 - Microsoft event
  {
    id: "10",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/5_sblbaf.jpg",
    url: "#",
    height: 340,
    eventName: "תמונה מאירוע של Microsoft",
    clientQuote: "הפרופסיונליזם והיצירתיות הם ללא תחרות"
  },
  // תמונה #4 - Office event
  {
    id: "4",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8625_mmxgam.jpg",
    url: "#",
    height: 280,
    eventName: "תמונה מאירוע משרדי",
    clientQuote: "הצוות הגיע מוכן ומאורגן, הכל היה מושלם"
  },
  // תמונה #26 - Medium lighting
  {
    id: "26",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561452/_DSC8153_ltlzux.jpg",
    url: "#",
    height: 280,
    eventName: "תמונה מאירוע נהדר",
    clientQuote: "חוויה בלתי נשכחת"
  },

  // תמונות בינוניות - Medium-Toned Images
  // תמונה #12 - Product launch
  {
    id: "12",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/7_msnpro.jpg",
    url: "#",
    height: 360,
    eventName: "תמונה מאירוע השקת מוצר",
    clientQuote: "הבר הוסיף מגע יוקרתי שהרים את האירוע לרמה אחרת"
  },
  // תמונה #23 - Luxury event
  {
    id: "23",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/PS1_0054_resized_w2sjm6.jpg",
    url: "#",
    height: 220,
    eventName: "תמונה מאירוע יוקרה",
    clientQuote: "כל רגע היה מושלם עם השירות המקצועי שלכם"
  },
  // תמונה #5 - Launch event
  {
    id: "5",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8712_lzngrk.jpg",
    url: "#",
    height: 200,
    eventName: "תמונה מאירוע השקה",
    clientQuote: "החוויה עלתה על כל הציפיות שלנו"
  },
  // תמונה #9 - Social event
  {
    id: "9",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/4_j2jjfl.jpg",
    url: "#",
    height: 220,
    eventName: "תמונה מאירוע חברתי",
    clientQuote: "האווירה שיצרתם הייתה בדיוק מה שחלמנו עליו"
  },
  // תמונה #30 - Medium-dark event
  {
    id: "30",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561448/_DSC5381_h3dqiz.jpg",
    url: "#",
    height: 310,
    eventName: "תמונה מאירוע מרגש",
    clientQuote: "רגעים שנשארים לנצח"
  },
  // תמונה #27 - Special event
  {
    id: "27",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561448/_DSC4323_kopuin.jpg",
    url: "#",
    height: 300,
    eventName: "תמונה מאירוע מיוחד",
    clientQuote: "פרטים קטנים שעושים את ההבדל"
  },

  // תמונות בינוניות-כהות - Medium-Dark Images
  // תמונה #13 - Special event
  {
    id: "13",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561463/5_1_yzwbnm.jpg",
    url: "#",
    height: 250,
    eventName: "תמונה מאירוע מיוחד",
    clientQuote: "השירות היה מהיר ויעיל, בדיוק מה שהיינו צריכים"
  },
  // תמונה #11 - Gala event
  {
    id: "11",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/6_vacdea.jpg",
    url: "#",
    height: 280,
    eventName: "תמונה מאירוע גאלה",
    clientQuote: "כל פרט היה מושלם, מההכנה ועד הביצוע"
  },
  // תמונה #14 - VIP event
  {
    id: "14",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/9_izc4gs.jpg",
    url: "#",
    height: 310,
    eventName: "תמונה מאירוע VIP",
    clientQuote: "חוויה בלתי נשכחת עם שירות ברמה עולמית"
  },
  // תמונה #28 - Darker ambient
  {
    id: "28",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561448/_DSC5915_ckqj3e.jpg",
    url: "#",
    height: 260,
    eventName: "תמונה מאירוע בלתי נשכח",
    clientQuote: "אווירה מדהימה"
  },
  // תמונה #29 - Perfect event
  {
    id: "29",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561446/_DSC4627_ivnvt9.jpg",
    url: "#",
    height: 290,
    eventName: "תמונה מאירוע מושלם",
    clientQuote: "כל הפרטים במקום"
  },

  // תמונות כהות - Dark/Moody Images
  // תמונה #1 - Evening cocktail event
  {
    id: "1",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC7926_l9h2sv.jpg",
    url: "#",
    height: 320,
    eventName: "תמונה מאירוע קוקטיילים מקצועי",
    clientQuote: "הקוקטיילים היו פשוט מעולים והשירות היה מקצועי ביותר"
  },
  // תמונה #3 - Private social event (darker ambiance)
  {
    id: "3",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8091_qmgv1z.jpg",
    url: "#",
    height: 380,
    eventName: "תמונה מאירוע חברתי פרטי",
    clientQuote: "המיקסולוג היה אמן אמיתי, כל קוקטייל היה יצירת אמנות"
  },
  // תמונה #18 - Dramatic lighting
  {
    id: "18",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561478/IMG_1242_fa97vn.jpg",
    url: "#",
    height: 380,
    eventName: "תמונה מאירוע מרהיב",
    clientQuote: "השירות עלה על כל הציפיות והיה ללא רבב"
  },
  // תמונה #19 - Luxury dark tone
  {
    id: "19",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561477/Gleb_Smirnov-Productions-5226_mdsuxe.jpg",
    url: "#",
    height: 280,
    eventName: "תמונה מאירוע יוקרתי",
    clientQuote: "האירוע היה הצלחה מוחלטת בזכות הבר המקצועי"
  },
  // תמונה #32 - Dark sophisticated
  {
    id: "32",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561477/Gleb_Smirnov-Productions-6407_ph5r2p.jpg",
    url: "#",
    height: 330,
    eventName: "תמונה מאירוע מושלם",
    clientQuote: "פרטים שעושים את ההבדל"
  },
  // תמונה #20 - Dark artistic
  {
    id: "20",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561461/_DSC8819_htw9tm.jpg",
    url: "#",
    height: 200,
    eventName: "תמונה מאירוע מושלם",
    clientQuote: "הקוקטיילים היו יצירות אמנות אמיתיות"
  },
  // תמונה #31 - Evening mood
  {
    id: "31",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561461/_DSC8813_fp3wyr.jpg",
    url: "#",
    height: 270,
    eventName: "תמונה מאירוע יפהפה",
    clientQuote: "רגעים קסומים"
  },
  // תמונה #21 - Dark dramatic
  {
    id: "21",
    img: "https://res.cloudinary.com/doteohz34/image/upload/v1763561447/_DSC4408_fxde7s.jpg",
    url: "#",
    height: 260,
    eventName: "תמונה מאירוע מדהים",
    clientQuote: "השילוב בין טעם מושלם לעיצוב מרהיב"
  },
  // תמונה #24 - Background dark tone
  {
    id: "24",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/%D7%AA%D7%9E%D7%95%D7%A0%D7%94_%D7%A9%D7%9C_WhatsApp_2025-08-01_%D7%91%D7%A9%D7%A2%D7%94_15.15.18_e1cab6e8_nesoy5.jpg",
    url: "#",
    height: 340,
    eventName: "תמונה מאירוע רקע",
    clientQuote: "האווירה שיצרתם הייתה בדיוק מה שדמיינו"
  },

  // תמונות חדשות מ-19 בנובמבר 2025
  {
    id: "33",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/PS1_0056_resized_dp0qat.jpg",
    url: "#",
    height: 380,
    eventName: "תמונה מאירוע יוקרתי",
    clientQuote: "רמת השירות והמקצועיות הייתה יוצאת דופן"
  },
  {
    id: "34",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/PS1_0053_resized_aoiffp.jpg",
    url: "#",
    height: 380,
    eventName: "תמונה מאירוע אלגנטי",
    clientQuote: "כל פרט היה מתוכנן בקפידה"
  },
  {
    id: "35",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/PS1_0051_resized_xczman.jpg",
    url: "#",
    height: 380,
    eventName: "תמונה מאירוע מושלם",
    clientQuote: "חוויה בלתי נשכחת מתחילה ועד סוף"
  },
  {
    id: "36",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/IMG_6077_dq5mmo.jpg",
    url: "#",
    height: 320,
    eventName: "תמונה מאירוע חברתי",
    clientQuote: "האווירה הייתה מדהימה והשירות ללא דופי"
  },
  {
    id: "37",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/IMG_0340_kqkoqz.jpg",
    url: "#",
    height: 280,
    eventName: "תמונה מאירוע מרגש",
    clientQuote: "כל רגע היה מלא בקסם ויופי"
  },
  {
    id: "38",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/IMG_1268_xu4v9h.jpg",
    url: "#",
    height: 300,
    eventName: "תמונה מאירוע מיוחד",
    clientQuote: "שירות יוצא מן הכלל ברמה הגבוהה ביותר"
  },
  {
    id: "39",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/image00012_xr884e.jpg",
    url: "#",
    height: 350,
    eventName: "תמונה מאירוע נהדר",
    clientQuote: "הקוקטיילים היו פשוט מושלמים"
  },
  {
    id: "40",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/IMG_0399_mzdhak.jpg",
    url: "#",
    height: 220,
    eventName: "תמונה מאירוע עסקי",
    clientQuote: "המקצועיות והתשומת לב לפרטים הקטנים"
  },
  {
    id: "41",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-6401_c5u4hl.jpg",
    url: "#",
    height: 260,
    eventName: "צילום מקצועי",
    clientQuote: "רגעים מושלמים שנלכדו במצלמה"
  },
  {
    id: "42",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2805_xtsxhb.jpg",
    url: "#",
    height: 250,
    eventName: "אירוע יוקרתי",
    clientQuote: "אלגנטיות וטעם מעולה בכל פרט"
  },
  {
    id: "43",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-5218_vmlw47.jpg",
    url: "#",
    height: 280,
    eventName: "אירוע מרשים",
    clientQuote: "השירות עלה על כל הציפיות"
  },
  {
    id: "44",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2675_jylf54.jpg",
    url: "#",
    height: 260,
    eventName: "אירוע אלגנטי",
    clientQuote: "כל האורחים היו מרוצים מהשירות"
  },
  {
    id: "45",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2736_c5ejig.jpg",
    url: "#",
    height: 260,
    eventName: "אירוע מושלם",
    clientQuote: "רמת המקצועיות הייתה יוצאת דופן"
  },
  {
    id: "46",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2741_naqg9w.jpg",
    url: "#",
    height: 310,
    eventName: "אירוע מיוחד",
    clientQuote: "חוויה שתישאר איתנו לתמיד"
  },
  {
    id: "47",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2737_vkecku.jpg",
    url: "#",
    height: 260,
    eventName: "אירוע בלתי נשכח",
    clientQuote: "כל פרט היה מתוכנן בצורה מושלמת"
  },
  {
    id: "48",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2664_udvtle.jpg",
    url: "#",
    height: 260,
    eventName: "אירוע מרגש",
    clientQuote: "השירות היה מעל ומעבר"
  },
  {
    id: "49",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2698_nzozog.jpg",
    url: "#",
    height: 260,
    eventName: "אירוע חברתי",
    clientQuote: "האווירה הייתה פשוט מושלמת"
  },
  {
    id: "50",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2554_hq76oe.jpg",
    url: "#",
    height: 270,
    eventName: "אירוע מדהים",
    clientQuote: "הצוות היה מקצועי ואדיב"
  },
  {
    id: "51",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/Gleb_Smirnov-Productions-2660_l6smr6.jpg",
    url: "#",
    height: 260,
    eventName: "אירוע נהדר",
    clientQuote: "כל קוקטייל היה יצירת אמנות"
  },
  {
    id: "52",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/20240521-195837-DSY_4185-R3_lh1qtf.jpg",
    url: "#",
    height: 240,
    eventName: "אירוע מיוחד",
    clientQuote: "רגעים קסומים שנשמרים בזיכרון"
  },
  {
    id: "53",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/2024-09-06GAVRIEL-120_d6d8y3.jpg",
    url: "#",
    height: 250,
    eventName: "אירוע גאלה",
    clientQuote: "השירות היה ברמה הגבוהה ביותר"
  },
  {
    id: "54",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/51_dxvbxh.jpg",
    url: "#",
    height: 290,
    eventName: "אירוע אלגנטי",
    clientQuote: "כל פרט היה מושלם"
  },
  {
    id: "55",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/14_lr5fsj.jpg",
    url: "#",
    height: 290,
    eventName: "אירוע חגיגי",
    clientQuote: "חוויה בלתי נשכחת"
  },
  {
    id: "56",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC9018_vdv9vk.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע מרשים",
    clientQuote: "הקוקטיילים היו מעולים"
  },
  {
    id: "57",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/5_qy7u3o.jpg",
    url: "#",
    height: 290,
    eventName: "אירוע יפהפה",
    clientQuote: "שירות מקצועי וחם"
  },
  {
    id: "58",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/4_1_tez42h.jpg",
    url: "#",
    height: 200,
    eventName: "אירוע מושלם",
    clientQuote: "כל רגע היה מיוחד"
  },
  {
    id: "59",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC9006_n9emal.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע נפלא",
    clientQuote: "האווירה הייתה קסומה"
  },
  {
    id: "60",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8896_gtv2lc.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע מדהים",
    clientQuote: "הצוות עבד בצורה מעולה"
  },
  {
    id: "61",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8882_kvqhq3.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע זכור",
    clientQuote: "כל האורחים נהנו מאוד"
  },
  {
    id: "62",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8456_wdulob.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע מרגש",
    clientQuote: "השירות היה יוצא מן הכלל"
  },
  {
    id: "63",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8307_xosdgz.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע חברתי",
    clientQuote: "אווירה נהדרת וקוקטיילים מושלמים"
  },
  {
    id: "64",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8668_bvbhvn.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע יוקרתי",
    clientQuote: "רמת השירות הייתה מדהימה"
  },
  {
    id: "65",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8211_pnjdne.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע אלגנטי",
    clientQuote: "כל פרט היה מתואם בצורה מושלמת"
  },
  {
    id: "66",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8103_lzpsmr.jpg",
    url: "#",
    height: 200,
    eventName: "אירוע מושלם",
    clientQuote: "הקוקטיילים היו פשוט מעולים"
  },
  {
    id: "67",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8173_ncghbb.jpg",
    url: "#",
    height: 220,
    eventName: "אירוע מיוחד",
    clientQuote: "חוויה שלא נשכח"
  },
  {
    id: "68",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8160_latpai.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע נהדר",
    clientQuote: "השירות היה ברמה הכי גבוהה"
  },
  {
    id: "69",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8044_lwrlz7.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע מרשים",
    clientQuote: "כל רגע היה מלא במגיה"
  },
  {
    id: "70",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8053_ysi9bw.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע בלתי נשכח",
    clientQuote: "האווירה הייתה מושלמת"
  },
  {
    id: "71",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC8037_gfwjv5.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע מדהים",
    clientQuote: "הצוות היה מקצועי ונעים"
  },
  {
    id: "72",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC7982_jfcdjc.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע חגיגי",
    clientQuote: "כל האורחים היו מרוצים"
  },
  {
    id: "73",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC7923_txjiki.jpg",
    url: "#",
    height: 300,
    eventName: "אירוע מושלם",
    clientQuote: "שירות יוצא מן הכלל"
  },
  {
    id: "74",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC6112_dg8mwd.jpg",
    url: "#",
    height: 320,
    eventName: "אירוע יוקרתי",
    clientQuote: "הקוקטיילים היו מושלמים"
  },
  {
    id: "75",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC7911_i0omwa.jpg",
    url: "#",
    height: 200,
    eventName: "אירוע מרגש",
    clientQuote: "רגעים יפים שנשמרו בזיכרון"
  },
  {
    id: "76",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC6068_alg1le.jpg",
    url: "#",
    height: 330,
    eventName: "אירוע נפלא",
    clientQuote: "אווירה מדהימה"
  },
  {
    id: "77",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC6109_vrtq3k.jpg",
    url: "#",
    height: 360,
    eventName: "אירוע אלגנטי",
    clientQuote: "שירות ברמה גבוהה"
  },
  {
    id: "78",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC6105_jjq9h5.jpg",
    url: "#",
    height: 350,
    eventName: "אירוע מיוחד",
    clientQuote: "כל פרט היה מושלם"
  },
  {
    id: "79",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC6058_nls0z4.jpg",
    url: "#",
    height: 340,
    eventName: "אירוע מושלם",
    clientQuote: "חוויה בלתי נשכחת"
  },
  {
    id: "80",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC6009_pbqyii.jpg",
    url: "#",
    height: 360,
    eventName: "אירוע נהדר",
    clientQuote: "הקוקטיילים היו מעולים"
  },
  {
    id: "81",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC4357_nvktze.jpg",
    url: "#",
    height: 360,
    eventName: "אירוע מרשים",
    clientQuote: "השירות היה יוצא דופן"
  },
  {
    id: "82",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC5928_javwoz.jpg",
    url: "#",
    height: 250,
    eventName: "אירוע חברתי",
    clientQuote: "אווירה נהדרת"
  },
  {
    id: "83",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC5312_nyox8e.jpg",
    url: "#",
    height: 360,
    eventName: "אירוע אלגנטי",
    clientQuote: "כל רגע היה מיוחד"
  },
  {
    id: "84",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC4324_qkjpai.jpg",
    url: "#",
    height: 370,
    eventName: "אירוע מושלם",
    clientQuote: "שירות מקצועי מאוד"
  },
  {
    id: "85",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC5291_lnvvmp.jpg",
    url: "#",
    height: 360,
    eventName: "אירוע יוקרתי",
    clientQuote: "הקוקטיילים היו יצירות אמנות"
  },
  {
    id: "86",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC4390_ksdfkj.jpg",
    url: "#",
    height: 360,
    eventName: "אירוע מיוחד",
    clientQuote: "חוויה שלא תישכח"
  },
  {
    id: "87",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC4321_ygitwi.jpg",
    url: "#",
    height: 360,
    eventName: "אירוע נפלא",
    clientQuote: "כל פרט היה מתוכנן בצורה מושלמת"
  },
  {
    id: "88",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC4516_hp6yqd.jpg",
    url: "#",
    height: 360,
    eventName: "אירוע מדהים",
    clientQuote: "השירות היה ללא דופי"
  },
  {
    id: "89",
    img: "https://res.cloudinary.com/doteohz34/image/upload/q_auto,f_auto,w_600/_DSC4315_qoojkk.jpg",
    url: "#",
    height: 260,
    eventName: "אירוע בלתי נשכח",
    clientQuote: "אווירה מושלמת וקוקטיילים מעולים"
  }
];

// Main page gallery items - curated selection of best 44 images for MAINPAGE.jsx
// Mix of high-profile events, best quality images, and variety
export const mainPageGalleryItems = [
  galleryItems[0],  // #22 Fashion photoshoot
  galleryItems[1],  // #17 Business event
  galleryItems[2],  // #16 Private event
  galleryItems[3],  // #2 Amazon event
  galleryItems[4],  // #25 Contemporary
  galleryItems[5],  // #7 Wedding
  galleryItems[6],  // #6 Google event
  galleryItems[7],  // #8 Birthday
  galleryItems[8],  // #10 Microsoft
  galleryItems[9],  // #4 Office event
  galleryItems[10], // #26 Medium lighting
  galleryItems[11], // #12 Product launch
  galleryItems[12], // #23 Luxury event
  galleryItems[13], // #5 Launch event
  galleryItems[14], // #9 Social event
  galleryItems[15], // #30 Medium-dark
  galleryItems[16], // #27 Special event
  galleryItems[17], // #13 Special event
  galleryItems[18], // #11 Gala event
  galleryItems[19], // #14 VIP event
  galleryItems[20], // #28 Darker ambient
  galleryItems[21], // #29 Perfect event
  galleryItems[22], // #1 Evening cocktail
  galleryItems[23], // #3 Private social
  galleryItems[24], // #18 Dramatic lighting
  galleryItems[25], // #19 Luxury dark
  galleryItems[26], // #32 Dark sophisticated
  galleryItems[27], // #20 Dark artistic
  galleryItems[28], // #31 Evening mood
  galleryItems[29], // #21 Dark dramatic
  galleryItems[30], // #24 Background dark
  galleryItems[31], // #33 New images
  galleryItems[32], // #34
  galleryItems[33], // #35
  galleryItems[34], // #36
  galleryItems[36], // #38
  galleryItems[37], // #39
  galleryItems[39], // #41 Professional photography
  galleryItems[40], // #42 Luxury event
  galleryItems[41], // #43 Impressive event
  galleryItems[55], // #57 Beautiful event
  galleryItems[72], // #74 Luxury event
  galleryItems[75], // #77 Elegant event
  galleryItems[87]  // #89 Unforgettable event
];

// Mobile-specific gallery items (10 images for perfect 2-column layout: 5 per column)
// Selected to show progression from light to dark tones
export const mobileGalleryItems = [
  // Light images
  {
    ...galleryItems[0], // #22 Fashion photoshoot (brightest)
    height: 280 // Standardized height
  },
  {
    ...galleryItems[2], // #16 Private event (bright)
    height: 280
  },
  // Medium-bright images
  {
    ...galleryItems[6], // #7 Wedding event
    height: 280
  },
  {
    ...galleryItems[7], // #6 Google event
    height: 280
  },
  // Medium images
  {
    ...galleryItems[12], // #12 Product launch
    height: 280
  },
  {
    ...galleryItems[15], // #27 Special event
    height: 280
  },
  // Medium-dark images
  {
    ...galleryItems[18], // #11 Gala event
    height: 280
  },
  // Dark images
  {
    ...galleryItems[23], // #1 Evening cocktail (darker)
    height: 280
  },
  {
    ...galleryItems[25], // #19 Luxury dark
    height: 280
  },
  {
    ...galleryItems[30], // #24 Background dark (darkest)
    height: 280
  }
];

export const servicesData = [
  {
    image: "https://via.placeholder.com/500x400/ff6b35/FFFFFF?text=בר+לאירועים+פרטיים",
    text: "בר לאירועים פרטיים"
  },
  {
    image: "https://via.placeholder.com/500x400/f7931e/FFFFFF?text=בר+לאירועי+חברה", 
    text: "בר לאירועי חברה"
  },
  {
    image: "https://via.placeholder.com/500x400/2C3E50/FFFFFF?text=בר+להפקות",
    text: "בר להפקות"
  },
  {
    image: "https://via.placeholder.com/500x400/8B2635/FFFFFF?text=בר+להשקות",
    text: "בר להשקות"
  },
  {
    image: "https://via.placeholder.com/500x400/C9A14B/1A365D?text=בר+למסיבות",
    text: "בר למסיבות"
  }
];

export const clientLogos = [
  "https://res.cloudinary.com/doteohz34/image/upload/q_auto:best,f_auto,w_200/Forbs_myoluf.png",
  "https://res.cloudinary.com/doteohz34/image/upload/q_auto:best,f_auto,w_200/image-removebg-preview_43_rytkux.png",
  "https://res.cloudinary.com/doteohz34/image/upload/q_auto:best,f_auto,w_200/image-removebg-preview_44_ifam99.png",
  "https://res.cloudinary.com/doteohz34/image/upload/q_auto:best,f_auto,w_200/image-removebg-preview_45_ntzueh.png",
  "https://res.cloudinary.com/doteohz34/image/upload/q_auto:best,f_auto,w_200/image-removebg-preview_47_eofrhp.png",
  "https://res.cloudinary.com/doteohz34/image/upload/q_auto:best,f_auto,w_200/land_rover_funy9t.png"
];

export const features = [
  { icon: '🍹', text: 'קוקטיילים מקצועיים' },
  { icon: '🎉', text: 'חוויה בלתי נשכחת' },
  { icon: '⚡', text: 'שירות מהיר ויעיל' },
  { icon: '🎯', text: 'התאמה אישית מלאה' },
  { icon: '🏆', text: 'איכות ללא פשרות' },
  { icon: '🌟', text: 'חומרי גלם איכותיים' },
  { icon: '👨‍🍳', text: 'מיקסולוגים מנוסים' },
  { icon: '💎', text: 'שירות VIP' }
];